import React from 'react';
import s from './Image.css';

class Image extends React.Component {

 constructor() {
    super();
    this.state = { opacity: 0 };
  }

  fadeIn = () => {
    this.setState({ opacity: 1 });
  };

  render() {
    // this vs including an Object.assign polyfill
    const { src, speed } = this.props;
    const style = this.props.style || {};
    style.transition = `opacity ${speed || 0.5}s`;
    style.opacity = this.state.opacity;
    return (
      <img
        alt={'loaded'}
        className={s.Image}
        {...this.props}
        style={style}
        src={src}
        onLoad={this.fadeIn}
      />);
  }
}

Image.propTypes = {
  src: React.PropTypes.string.isRequired,
  speed: React.PropTypes.number,
  style: React.PropTypes.string
};

export default Image;



/** WEBPACK FOOTER **
 ** ./components/Utils/Image.js
 **/